import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import Select from "react-select";

import { baseURL } from "../../../../utils/http/http-common";
import Card from "../../../../utils/card/Card";

const StateSchoolType = ({
  name,
  selectedBoard,
  selectedState,
  setSelectedBoard,
  setSelectedState,
  handleProceedButton,
}) => {
  const [states, setStates] = useState([]);
  const [boards, setBoards] = useState([]);

  const [isStateLoading, setIsStateLoading] = useState(false);
  const [isBoardLoading, setIsBoardLoading] = useState(false);

  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const stateOptions = useMemo(
    () =>
      states.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    [states],
  );

  const boardOptions = useMemo(
    () =>
      boards.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    [boards],
  );

  const getAllStates = useCallback(async () => {
    try {
      setIsStateLoading(true);

      const { data } = await axios.get(`${baseURL}/State`);

      setStates(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch states:", error);
      setStates([]);
    } finally {
      setIsStateLoading(false);
    }
  }, []);

  const getStateBoards = useCallback(async (stateId) => {
    if (!stateId) {
      setBoards([]);
      return;
    }

    try {
      setIsBoardLoading(true);

      const { data } = await axios.get(
        `${baseURL}/SchoolType/GetSchoolTypeByState/${stateId}/1`,
      );

      setBoards(data?.response || []);
    } catch (error) {
      console.error("Failed to fetch boards:", error);
      setBoards([]);
    } finally {
      setIsBoardLoading(false);
    }
  }, []);

  useEffect(() => {
    getAllStates();
  }, [getAllStates]);

  useEffect(() => {
    setSelectedBoard(null);
    setBoards([]);

    if (selectedState?.value) {
      getStateBoards(selectedState.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState, getStateBoards]);

  const handleStateChange = (option) => {
    setSelectedState(option);
  };

  const handleBoardChange = (option) => {
    setSelectedBoard(option);
  };

  const getTextTranslated = [];

  useEffect(() => {
    setIsButtonEnabled(!!selectedState && !!selectedBoard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState, selectedBoard]);

  return (
    <div className="bg-gradient-to-b from-[#0606062b] to-[#0DE9FF2B] my-[75px] md:my-[200px] lg:my-[75px] lg:mx-[20px] lg:mx-[150px] xl:mx-[280px] xl:my-[50px] p-4 rounded-md drop-shadow-[0_04px_20px_#00000021]">
      <div className="grid grid-cols-1 md:grid-cols-3 bg-[#FDFDFD] rounded-md p-4">
        <div className="col-span-1">
          <Card height={"[50px]"} color="#101942" className="min-h-full" />
        </div>
        <div className="col-span-2 my-4 ">
          <div className="p-[20px]">
            <div className="text-left w-[100%] mb-6">
              <label htmlFor="state" className="text-[15px] mb-0 text-left">
                Choose your State
                <span className="text-red-500">*</span>
              </label>

              <Select
                inputId="state"
                className="mt-2"
                value={selectedState}
                options={stateOptions}
                isLoading={isStateLoading}
                isClearable
                placeholder="Select State"
                onChange={handleStateChange}
              />
            </div>

            <div className=" text-left w-[100%]">
              <label htmlFor="board" className="text-[15px] mb-0 text-left">
                Choose your Board
                <span className="text-red-500">*</span>
              </label>

              <Select
                inputId="board"
                className="mt-2"
                value={selectedBoard}
                options={boardOptions}
                isLoading={isBoardLoading}
                isDisabled={!selectedState}
                isClearable
                placeholder={
                  selectedState ? "Select Board" : "Select State First"
                }
                onChange={handleBoardChange}
              />
            </div>
          </div>
          <div className="flex justify-center">
            <button
              className={`relative w-[75%] px-[40px] py-[10px] rounded-[10px] mt-[20px] text-center flex flex-row justify-center items-center ${"bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-white cursor-pointer"}`}
              onClick={() => {
                handleProceedButton();
              }}
              disabled={!isButtonEnabled}
            >
              {getTextTranslated?.data?.length > 0
                ? getTextTranslated?.data?.filter(
                    (item) => item.pageKey === "btn_proceed",
                  )[0].keyValue
                : "Proceed"}
              <span className="bg-[#586084] p-[8px] rounded-[100%] absolute right-3 top-[12px] md:top-[8px]">
                <img src="../right-arrow.png" className="w-[8px] h-[10px]" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateSchoolType;
